module.exports = __webpack_public_path__ + "img/box.dfde6631.png";